module.exports = __webpack_public_path__ + "static/img/pic_1.84e01cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon/pic_1.png
// module id = W4Mn
// module chunks = 0